import { DirectiveBinding } from 'vue/types/options';
import { DirectiveOptions } from 'vue';

interface OnScrollRecord {
    handler: any;
    options?: boolean | EventListenerOptions;
    target?: any;
}

interface ScrollHTMLElement extends HTMLElement {
    __onScroll?: OnScrollRecord;
}

function inserted(el: ScrollHTMLElement, binding: DirectiveBinding) {
  const value = binding.value;
  const handler = typeof value === 'function' || 'handleEvent' in value ? value : value.handler;
  const options = (typeof value === 'object' && value.options) || { passive: true } as EventListenerOptions;

  el.addEventListener('scroll', handler, options);

  el.__onScroll = {
    handler,
    options,
  };
}

function unbind(el: ScrollHTMLElement) {
  if (!el.__onScroll) return;

  const { handler, options } = el.__onScroll;
  el.removeEventListener('scroll', handler, options as EventListenerOptions);
  delete el.__onScroll;
}

export const ScrollDirective = {
  inserted,
  unbind,
} as DirectiveOptions;

export default ScrollDirective;
